import axios from 'axios'

const api = axios.create({ baseURL: '/api' })

api.interceptors.request.use(config => {
  const usuario = sessionStorage.getItem('frotaweb_user')
  if (usuario) {
    config.headers['X-Usuario'] = usuario
    sessionStorage.setItem('frotaweb_last_activity', String(Date.now()))
  }
  return config
})

// Usuário desativado no Cadastro de Usuários: encerra a sessão e volta pro login com o aviso
api.interceptors.response.use(undefined, erro => {
  if (erro?.response?.status === 401 && erro.response.data?.codigo === 'USUARIO_DESATIVADO' && sessionStorage.getItem('frotaweb_user')) {
    ;['frotaweb_user', 'frotaweb_tiplib', 'frotaweb_perfil', 'frotaweb_last_activity'].forEach(k => sessionStorage.removeItem(k))
    sessionStorage.setItem('frotaweb_aviso_login', 'Seu usuário foi desativado. Procure o administrador do sistema.')
    window.location.assign('/')
  }
  return Promise.reject(erro)
})

// master = nosso usuário fixo (Administrador); super = usu_super 'S' do ERP; os dois têm acesso total
export type PerfilUsuario = 'master' | 'super' | 'comum'
export function perfilUsuario(): PerfilUsuario {
  const p = sessionStorage.getItem('frotaweb_perfil')
  return p === 'master' || p === 'super' ? p : 'comum'
}
export const ehAdministrador = () => perfilUsuario() !== 'comum'

export async function login(usuario: string, senha: string) {
  const res = await api.post('/auth/login', { usuario, senha })
  return res.data
}

export async function listDocuments(limit = 50) {
  const res = await api.get('/documents', { params: { limit } })
  return res.data
}

export async function getDocument(empCod: number, serie: string, numero: number) {
  const res = await api.get(`/documents/${empCod}/${encodeURIComponent(serie)}/${numero}`)
  return res.data
}

export async function getItems(empCod: number, serie: string, numero: number) {
  const res = await api.get(`/documents/${empCod}/${encodeURIComponent(serie)}/${numero}/items`)
  return res.data
}

export async function getHistory(empCod: number, serie: string, numero: number) {
  const res = await api.get(`/documents/${empCod}/${encodeURIComponent(serie)}/${numero}/history`)
  return res.data
}

export async function emitNfe(payload: any) {
  const res = await api.post('/nfe/emitir', payload)
  return res.data
}

export async function emitCte(payload: any) {
  const res = await api.post('/cte/emitir', payload)
  return res.data
}

export async function transmitNfe(empCod: number, serie: string, numero: number) {
  const res = await api.post(`/nfe/${empCod}/${encodeURIComponent(serie)}/${numero}/transmit`)
  return res.data
}

export async function cancelDocument(empCod: number, serie: string, numero: number, body: any) {
  const res = await api.post(`/documents/${empCod}/${encodeURIComponent(serie)}/${numero}/cancel`, body)
  return res.data
}

export default api
